<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">任务管理</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="任务名称">
            <el-input v-model="ProjectTaskNmae" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item label="执行方">
            <el-input v-model="ProjectExcuteNmae" placeholder="请输入执行方"></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <el-button @click="onBack()">返回</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd" v-show="IsEdit">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="ProjectTaskName" label="任务名称"></el-table-column>
              <el-table-column prop="ProjectTaskStartTime" label="始时间" :formatter="formatDate"></el-table-column>
              <el-table-column prop="ProjectTaskEndTime" label="结束时间" :formatter="formatDate"></el-table-column>
              <el-table-column prop="ProjectTaskExcute" label="执行方"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="EditDetail(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small" v-show="IsEdit"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "ProjectTaskManagement",
  controller: "UI",
  action: "ProjectTaskManagement",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      ProjectTaskNmae: "",
      ProjectExcuteNmae: "",
      loading: false,
      loadingText: "加载中...",
      tableData: [],
      ProjectId: "",
      ProjectName: "",
      IsEdit: true,
    };
  },
  created: function () {
    if (this.$route.query.InfoId) {
      this.ProjectId = this.$route.query.InfoId;
      this.search();
    }
    if (this.$route.query.ProjectName) {
      this.ProjectName = this.$route.query.ProjectName;
    }
    if (this.$route.query.ProjectStatus==3) {
      this.IsEdit = false;
    }
  },
  mounted: function () {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.ProjectTaskNmae = "";
      this.ProjectExcuteNmae = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    search() {
      let searchinfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        ProjectID: this.ProjectId,
        StartNumber: 0,
        EndNumber: 0,
      };
      if (this.ProjectTaskNmae && this.ProjectTaskNmae != "") {
        searchinfo.ProjectTaskName = this.ProjectTaskNmae;
      }
      if (this.ProjectExcuteNmae && this.ProjectExcuteNmae != "") {
        searchinfo.ProjectTaskExcute = this.ProjectExcuteNmae;
      }

      console.log(searchinfo);
      this.loadingText = "加载中...";
      this.loading = true;
      new MyApis.ProjectTaskApi()
        .GetPageContentByConditions(searchinfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.ContentList;
          this.total = r.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onAdd() {
      if (this.ProjectId) {
        this.$router.push({
          path: "/plugin/MaterialManage/UI/ProjectTaskInfo",
          query: {
            type: "add",
            ProjectID: this.ProjectId,
          },
        });
      }
    },
    EditDetail(index, row) {
      this.$router.push({
        path: "/plugin/MaterialManage/UI/ProjectTaskInfo",
        query: {
          InfoId: row.ID,
          module: this.ProjectName,
          submodule: row.ProjectTaskName,
          ProjectID: this.ProjectId,
          IsEdit:this.IsEdit,
          type: "edit",
        },
      });
    },
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        new MyApis.ProjectTaskApi()
          .DelItem(row)
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.loading = false;
            this.search();
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      });
    },
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
  },
};
</script>